import * as AllIcons from "ionicons/icons"; //All icons

const icons = new Proxy(Object.keys(AllIcons).reduce((map, elem) => {
	map[elem.toLowerCase()] = AllIcons[elem];
	return map;
}, {}), {
	get: function(target, name) {
		var icon = target[name = name.toString().toLowerCase().replace("-", "")];
		if (icon)
			return icon;

		for (var key in target)
		{
			if (key.indexOf(name) > -1)
				return target[key];
		}
	}
});

export default icons;